module.exports = __webpack_public_path__ + "img/text1.b93248bb.png";